import React, { useCallback, useContext, useEffect } from "react";
import { useState } from "react";
import {
  deleteEmployeeAcademics,
  employeeAcademics,
} from "../Service/profileService";
import { TostMsg } from "../../../../App";
import ComponentLoader from "../../../../Shared/Sidebar/ComponentLoader";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";

function UserEducationDetails({ employeeId }) {
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const [showContent, setSeleteContent] = useState([]);
  const [deleteItem, setDeleteItem] = useState({ DeleteId: 0, deleteType: "" });
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [academicsDatalist, setAcademicsDatalist] = useState();
  let history = useHistory();

  useEffect(() => {
    if (employeeId) {
      getEmployeeAcademics();
    }
  }, [employeeId]);

  async function getEmployeeAcademics() {
    const params = {
      OrgId: userDetails.OrgId,
      AcadId: 0,
      EmpId: employeeId,
    };
    try {
      const response = await employeeAcademics(params);
      let academicsData = response?.Data;
      const sortedData = [...academicsData].sort(
        (a, b) => new Date(b.EndDate) - new Date(a.EndDate)
      );
      setAcademicsDatalist(sortedData);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  async function getEditAcademic(academicDetails) {
    history.push(`/Education/${academicDetails?.id}`);
   
  }

  async function deleteAcademicDetails(event) {
    if (deleteItem?.DeleteId && deleteItem?.deleteType == "Academic") {
      let body = {
        Id: deleteItem?.DeleteId,
        ModifiedBy: userDetails?.EmpId,
      };
      setIsloading(true);
      let educationList = await deleteEmployeeAcademics(body);
      try {
        GetMasterSystemAlertList("Education_Deleted", 0);
        getEmployeeAcademics();
        setIsloading(false);
      } catch (err) {
        setIsloading(false);
        return false;
      }
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setSeleteContent(msg?.Desc);
      }
    });
  }, []);

  const addEducation = () => {
    history.push(`/AddEducation`);
  };

  return (
    <div>
      <div className="profile-about-me position-relation">
        <div className="pt-3 border-bottom-1">
          <div className="mb-0">
            <h4 className="text-primary mb-3 sumh4 addprofile-action">
              Education
              {userDetails?.EmpId == employeeId && (
                <span>
                  <a
                    className="edit-btncss mb-2 love-icon"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Add Education"
                    data-bs-toggle="modal"
                    onClick={() => {
                      addEducation();
                    }}
                  >
                    <img
                      src="/images/org-img/profile/add.png"
                      className="w-100"
                    />{" "}
                  </a>
                </span>
              )}
            </h4>

            <div className="row">
              <div className="col-12">
                <div className="icon-timeline">
                  {academicsDatalist?.map((Academic, index) => {
                    return (
                      <div className="timeline-item" key={index}>
                        {userDetails?.EmpId == employeeId && (
                          <img
                            
                            onClick={() => {
                              setDeleteItem({
                                DeleteId: Academic?.id,
                                deleteType: "Academic",
                              });
                              GetMasterSystemAlertList("Delete_Education", 1);
                            }}
                            src="/images/org-img/delete.png"
                            className="side-pen-icon"
                            title="Delete"
                            data-bs-toggle="modal"
                            data-bs-target="#delete-edu"
                          />
                        )}
                        {userDetails?.EmpId == employeeId && (
                          <img
                            style={{
                              marginRight: "24px",
                              
                            }}
                            onClick={() => {
                              getEditAcademic(Academic);
                              GetMasterSystemAlertList("edit_education", 1);
                            }}
                            src="/images/org-img/edit.png"
                            className="side-pen-icon"
                            title="Edit"
                            data-bs-toggle="modal"
                            // data-bs-target="#add-education"
                          />
                        )}
                        <div className="timeline-icon is-squared">
                          <img
                            className="avatar avatarimg"
                            src="/images/profile/Education.svg"
                          />
                        </div>
                        <div className="timeline-content">
                          <h5 className="exp-des">{Academic?.Degree}</h5>
                          <p className="exp-comp">
                            {Academic?.DegreeType}&nbsp;{Academic?.SchoolName && "-"} &nbsp;{Academic?.SchoolName}{Academic?.MajorSubject && ","}&nbsp;
                            {Academic?.MajorSubject}
                          </p>
                          <p className="edu-texh">
                            {moment(Academic?.StartDate).format("MMM DD YYYY")} &nbsp;- &nbsp;{moment(Academic?.EndDate).format("MMM DD YYYY")}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="delete-edu">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />             
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>{showContent}</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
               className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteAcademicDetails("delete")}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? <ComponentLoader /> : ""}
    </div>
  );
}
export default UserEducationDetails;
